/* tslint:disable */

import React from 'react';
import styled from 'styled-components';

interface ImageProps {
  readonly onClick?: () => any;
}
const MyImage = styled.img<ImageProps>`
  ${(props) =>
    props.onClick && {
      cursor: 'pointer',
    }
};
`

const Image = (props: any) => {
  let url
  let format = 'png'
  if (props.useJpg) {
    format = 'jpg'
  }



  let lang = '';

  console.log(process.env.REACT_APP_LANGUAGE)
  if(process.env.REACT_APP_LANGUAGE === 'es'){
    if(props.es){
      lang = '_ES';
    }
  }
  if (window.innerWidth < 400) {
    url = `https://res.cloudinary.com/dvjhedt3c/image/fetch/w_600,c_scale,f_${format}/`
  } else {
    url = `https://res.cloudinary.com/dvjhedt3c/image/fetch/f_${format}/`
  }
  return(
    <MyImage src={`${url}https://s3-us-west-1.amazonaws.com/uci-images/images/${props.name}${lang}.png`} srcSet={`${url}https://s3-us-west-1.amazonaws.com/uci-images/images/${props.name}@2x${lang}.png 2x`} {...props} />
  )
}

export default Image;



// WEBPACK FOOTER //
// ./src/atoms/Image.tsx